import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { PermissionsProvider } from '@/contexts/PermissionsContext';

interface TenantProtectedRouteProps {
  children: ReactNode;
}

export function TenantProtectedRoute({ children }: TenantProtectedRouteProps) {
  const { user, loading, isTenantMember, currentTenant } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto"></div>
          <p className="mt-4 text-muted-foreground">Carregando...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  if (!isTenantMember || !currentTenant) {
    return <Navigate to="/" replace />;
  }

  return <PermissionsProvider>{children}</PermissionsProvider>;
}
